import { Input } from "@/components/ui/input";
import { ChecklistPhotos } from "@/components/movein/ChecklistPhotos";
import { cn } from "@/lib/utils";

export const CONDITIONS = [
  { key: "good", label: "Good", on: "bg-emerald-600 text-white border-emerald-600", off: "text-emerald-700 border-emerald-200 hover:bg-emerald-50" },
  { key: "fair", label: "Fair", on: "bg-amber-500 text-white border-amber-500", off: "text-amber-700 border-amber-200 hover:bg-amber-50" },
  { key: "poor", label: "Poor", on: "bg-rose-600 text-white border-rose-600", off: "text-rose-700 border-rose-200 hover:bg-rose-50" },
  { key: "na", label: "N/A", on: "bg-slate-600 text-white border-slate-600", off: "text-slate-500 border-slate-200 hover:bg-slate-50" },
];

export function ChecklistItem({ checklistId, roomKey, item, locked, onPatch, onPhotosChange }) {
  const id = `${roomKey}-${item.key}`;
  return (
    <div className={cn("py-3.5 border-b border-slate-100 last:border-0", !locked && !item.condition && "bg-amber-50/40 -mx-2 px-2 rounded-lg")} data-testid={`checklist-item-${id}`}>
      <div className="flex flex-wrap items-center gap-3">
        <div className="flex-1 min-w-[160px] text-sm font-semibold text-slate-800">{item.label}</div>
        <div className="flex gap-1.5" role="radiogroup" aria-label={`${item.label} condition`}>
          {CONDITIONS.map((c) => {
            const active = item.condition === c.key;
            return (
              <button key={c.key} type="button" disabled={locked} role="radio" aria-checked={active}
                onClick={() => onPatch({ condition: active ? null : c.key })}
                data-testid={`checklist-cond-${id}-${c.key}`}
                className={cn("rounded-full border px-3 py-1 text-xs font-semibold transition-colors disabled:cursor-default", active ? c.on : c.off, locked && !active && "opacity-40")}>
                {c.label}
              </button>
            );
          })}
        </div>
      </div>
      {locked ? (
        item.note && <p className="text-xs text-slate-600 mt-2 whitespace-pre-wrap" data-testid={`checklist-note-${id}`}>{item.note}</p>
      ) : (
        <Input value={item.note || ""} onChange={(e) => onPatch({ note: e.target.value })} maxLength={500}
          placeholder="Notes — scratches, stains, missing items… (optional)" className="mt-2 h-9 text-sm" data-testid={`checklist-note-${id}`} />
      )}
      <ChecklistPhotos checklistId={checklistId} roomKey={roomKey} item={item} locked={locked} onChange={onPhotosChange} />
    </div>
  );
}
